// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RIgN","top":"styles_top__2Kvka","left":"styles_left__qdkTG","description":"styles_description__F0ezG"};